import { default as React } from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { GenericTable } from "components/GenericTable";
import EditableCell from "containers/common/EditableCell";
import { createElementIdFactory, createReusableTableElementIds } from "utils/elementIds";
import { PAGE_SIZES } from "utils/pageSizeConfig";
import "containers/common/List.css";
import "containers/common/Table.css";

import {
  createColumnHelper,
} from "@tanstack/react-table";

function HeadOfficePageLeaseList({
  data,
  isLoading,
  isAuthenticated,
  controlType,
  saveRecord,
  deleteRecord,
  updateTableState,
}) {

  const dataSet = 'headOfficeLeases';
  const columnHelper = createColumnHelper();
  const createId = React.useMemo(() => createElementIdFactory("head-office-page-lease-list"), []);
  const tableElementIds = React.useMemo(
    () => createReusableTableElementIds(createId, controlType || "table"),
    [createId, controlType]
  );

  // --- TanStack Table Setup ---
  const tableData = data || [];

  const columns = React.useMemo(
    () => [
      columnHelper.accessor("led_head_office_id", {
        id: "led_head_office_id",
        header: "Head Office ID",
        size: 60,
      }),
      columnHelper.accessor("property_key", {
        id: "property_key",
        header: "Cityscope Reference",
        cell: (e) => (
          <Link
            to={{
              pathname: `/properties/${e.getValue()}`,
            }}
          >
            {e.getValue()}
          </Link>
        ),
        size: 130,
      }),
      columnHelper.accessor("lease_id", {
        id: "lease_id",
        header: "Lease ID",
        cell: ({ cell, row }) => (
          <Link
            to={{
              pathname: `/properties/${row.original.property_key}/leases/${cell.getValue()}`,
            }}
          >
            {cell.getValue()}
          </Link>
        ),
        size: 60,
      }),
      columnHelper.accessor("tenant_name", {
        id: "tenant_name",
        header: "Tenant Name",
        cell: EditableCell,
        size: 175,
      }),
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  // --- Render Functions ---
  function renderHeadOfficeLeaseList() {
    return (
      <div id={createId("container")} className="headOfficeLeaseListsRender">
        <Row className="show-Container">
          <Col sm={12} md={12} lg={12}>
            {!isLoading && (
              <GenericTable
                section="head-office-lease-list"
                columns={columns}
                data={tableData}
                pageSize={PAGE_SIZES.headOfficeDetailLeaseTab}
                elementIds={tableElementIds}
                hasHeaderSorting={true}
                enablePagination={true}
                columnResizeMode="onChange"
                meta={{
                  updateData: (rowIndex, columnId, value) => {
                    updateTableState(rowIndex, columnId, value);
                  },
                  handleSave: async ({ row }) => {
                    const record = row.original;
                    try {
                      await saveRecord(dataSet, record);
                    } catch (err) {
                      console.error("Save failed:", err);
                    }
                  },
                  handleDelete: ({ row }) => {
                    deleteRecord(dataSet, row.original);
                  },
                }}
              />
            )}
          </Col>
        </Row>
      </div>
    );
  }

  return (
    <div id={createId("root")} className="HeadOfficeLeaseList">
      {isAuthenticated ? renderHeadOfficeLeaseList() : null}
    </div>
  );
}

export default HeadOfficePageLeaseList;